// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"15d3cb6a","251":"06ebbf51","348":"a7eb3a9d","364":"da9e8f87","571":"f4cb36b8"}[chunkId] + ".chunk.js";
};